import api from '@pray/shared/utils/api';

export async function updateContentChapters({ artistId = null, contentId = null, locale = null, chapters = null }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');
  if (!chapters) throw Error('Chapters are required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/chapters`;
  const response = await api.executePutRequest(url, { chapters });

  return response.data;
}
